import { createContext } from "react";

interface Context {
    isFromSmallDesktop?: boolean;
    isUntilSmallDesktop?: boolean;
    isUntilLargeMobile?: boolean;
    mobile?: boolean;
}

export const BreakpointContext = createContext<Context>({} as Context);
